import { Component } from "react";
import PropTypes from "prop-types";

class SliderHOC extends Component {
	state = {
		index: 0,
		touchStart: null,
		touchEnd: null,
		canAutoScroll: true,
		autoScrollCb: null,
	};

	previous = e => {
		if (e.preventDefault) e.preventDefault();
		if (e.stopPropagation) e.stopPropagation();

		if (this.state.autoScrollCb === null) {
			this.setAutoScroll();
		}

		const { index } = this.state;
		const { slides } = this.props;
		const potentialPrev = index - 1;
		const realPrev = potentialPrev >= 0 ? potentialPrev : slides.length - 1;
		if (realPrev !== index) {
			this.setState({
				index: realPrev,
			});
		}
	};

	next = e => {
		if (e.preventDefault) e.preventDefault();
		if (e.stopPropagation) e.stopPropagation();

		if (this.state.autoScrollCb === null) {
			this.setAutoScroll();
		}

		const { index } = this.state;
		const { slides } = this.props;
		const potentialNext = index + 1;
		const realNext = potentialNext <= slides.length - 1 ? potentialNext : 0;
		if (realNext !== index) {
			this.setState({
				index: realNext,
			});
		}
	};

	goTo = index => e => {
		if (e.preventDefault) e.preventDefault();
		if (e.stopPropagation) e.stopPropagation();

		const { slides } = this.props;
		// Stop if passing a wrong index
		if (! slides[index]) return;
		this.setState({ index });
	}

	onTouchStart = e => {
		this.setState({
			canAutoScroll: false,
			touchStart: e.targetTouches[0].clientX
		}, this.clearAutoScroll);
	};

	onTouchMove = e => {
		this.setState({
			canAutoScroll: true,
			touchEnd: e.targetTouches[0].clientX
		});
	};

	onTouchEnd = e => {
		const { touchStart, touchEnd } = this.state;

		if (touchStart === null || touchEnd === null) {
			this.setState({
				touchStart: null,
				touchEnd: null
			});
			return;
		}

		if (touchStart - touchEnd > 150) {
			this.next(e);
		}

		if (touchStart - touchEnd < 150) {
			this.previous(e);
		}

		this.setState({
			touchStart: null,
			touchEnd: null
		}, this.setAutoScroll);
	};

	setAutoScroll = () => {
		if (this.state.autoScrollCb === null) {
			this.setState({
				autoScrollCb: setInterval(() => {
					if (this.state.canAutoScroll) {
						this.next({});
					}
				}, this.props.slideInterval)
			});
		}
	}

	clearAutoScroll = (callback = () => {}) => {
		if (this.state.autoScrollCb !== null) {
			clearInterval(this.state.autoScrollCb);
			this.setState({
				autoScrollCb: null
			}, callback);
		}
	}

	componentDidMount() {
		if (window.location.search.indexOf("freeze") === -1) {
			this.setAutoScroll();
		}
	}

	componentWillUnmount() {
		this.clearAutoScroll();
	}

	handleMouseEnter = () => {
		this.setState({
			canAutoScroll: false
		}, this.clearAutoScroll);
	};

	handleMouseLeave = () => {
		this.setState({
			canAutoScroll: true
		}, this.setAutoScroll);
	};

	render() {
		const passedProps = {
			slides: this.props.slides,
			index: this.state.index,
			onTouchStart: this.onTouchStart,
			onTouchMove: this.onTouchMove,
			onTouchEnd: this.onTouchEnd,
			handleMouseEnter: this.handleMouseEnter,
			handleMouseLeave: this.handleMouseLeave,
			previous: this.previous,
			goTo: this.goTo,
			next: this.next,
			onMouseEnter: this.onMouseEnter,
			onMouseLeave: this.onMouseLeave,
		};

		return this.props.children(passedProps);
	}

	static propTypes = {
		children: PropTypes.func.isRequired,
		slides: PropTypes.array,
		slideInterval: PropTypes.number,
	};

	static defaultProps = {
		slides: [],
		slideInterval: 5000,
	};
}

export default SliderHOC;
